import React from "react";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";

const CancelButton = ({ children, ...rest }) => (
  <MDButton variant="outlined" color="secondary" {...rest}>
    {children}
  </MDButton>
);

CancelButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CancelButton;
